import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import Layout from "@/_LayoutsRelated/layout/Layout";
import UserAccountComponent from "@/pages/user/UserAccountComponent/UserAccountComponent";
var UserAccount = function UserAccount() {
  var _useTranslation = useTranslation(["web_user_account"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Layout, {
    hideFooter: true,
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    hideAppBanner: true,
    hasNavBar: true,
    pageName: "userAccount",
    mobileHasTitle: t("حسابي", {
      ns: "web_user_account"
    })
  }, /*#__PURE__*/React.createElement(UserAccountComponent, null));
};
export default UserAccount;